import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import AnalyzerDemoData from 'Pages/AnalyzersV2/@tour/DemoData'

// Demo shown by the Virtual Tour when no report is loaded: one row per provider, one column per site
const ROWS = [
	{ name: 'alphacars', country: 'GB', prices: [8.4, 9.0, 7.8] },
	{ name: 'peakrentals', country: 'GB', prices: [7.6, 8.2, 7.2] },
	{ name: 'horizoncars', country: 'GB', prices: [8.0, 8.6, 7.4] },
	{ name: 'eurodrive', country: 'GB', prices: [8.8, 9.2, 8.2] },
	{ name: 'swiftfleet', country: 'GB', prices: [7.8, 8.4, 7.0] },
]

const SITES = ['rentalspot.demo', 'pricefly.demo', 'bookride.demo']
const COLUMNS = SITES.map(label => ({ label }))

// The chart's single-site "Sites" filter (AppSitesAutocomplete in the real toolbar)
const SitesFilter = () => <Autocomplete
	size="small"
	disabled
	options={SITES}
	value={SITES[0]}
	sx={{ width: 200 }}
	renderInput={params => <TextField {...params} label="Sites" size="small"/>}
/>

export default function RatingDemoData() {
	return <AnalyzerDemoData
		isRating
		columns={COLUMNS}
		rows={ROWS}
		chart={{ title: 'Rating', type: 'column', extraAction: <SitesFilter/> }}
	/>
}
